import { useTranslation } from "react-i18next";
import { Button, Alert, Snackbar } from "@mui/material";
import { QuickActionsSubscribeDialog } from "./QuickActionsSubscribeDialog";
import { useState } from "react";
// @ts-ignore
import { useUserPref } from "components/user/useUserPref";

export const QuickActionsSubscribeButton = (props: any) => {
    const { tile } = props;
    const userPref = useUserPref(tile.userPreferenceName, false);
    const { t } = useTranslation();

    const [openSubscribeDialog, setOpenSubscribeDialog] = useState(false);
    const [openSuccessSnackbar, setOpenSuccessSnackbar] = useState(false);

    const handleClickOpenPaperlessBillingDialog = () => {
        setOpenSubscribeDialog(true);
    };

    const handleCloseSubscribeDialog = () => {
        setOpenSubscribeDialog(false);
    };

    const handleOnChangeSubscribeStatus = () => {
        userPref.setUserPref(tile.userPreferenceName, !(userPref.valueBool));
    };

    const handleOnSuccessSubscribeStatus = () => {
        setOpenSubscribeDialog(false);
        setOpenSuccessSnackbar(true);
        handleOnChangeSubscribeStatus();
    };

    const handleCloseSuccessSnackbar = (reason: any) => {
        if (reason === "clickaway") {
            return;
        }

        setOpenSuccessSnackbar(false);
    };

    return (
        <>
            <Button
                sx={{
                    my: "auto",
                    textAlign: 'center',
                    width: 130
                }}
                variant="contained"
                fullWidth
                size="small"
                title={tile.buttonName}
                data-cy-id={"quick_actions_widget_buttonName_" + tile.id}
                onClick={handleClickOpenPaperlessBillingDialog}
            >
                {userPref.valueBool ? t("Unsubscribe") : t("Subscribe")}
            </Button>
            <QuickActionsSubscribeDialog
                open={openSubscribeDialog}
                isSubscribed={userPref.valueBool}
                quickActionTitle={tile.title}
                handleClose={handleCloseSubscribeDialog}
                handleSuccess={handleOnSuccessSubscribeStatus}
            />
            <Snackbar
                open={openSuccessSnackbar}
                autoHideDuration={3000}
                onClose={handleCloseSuccessSnackbar}
            >
                <Alert
                    onClose={handleCloseSuccessSnackbar}
                    severity="success"
                    variant="filled"
                    sx={{ width: "100%", color: "#fff" }}
                >
                    {t("Successfully {{status}} ", { status: userPref.valueBool ? "subscribed" : "unsubscribed" })}
                </Alert>
            </Snackbar>
        </>
    );
};
